import EventTargetPolyfill from './eventTargetPolyfill'

const DEFAULT_DURATION = 5000

export class NotificationDispatcher extends EventTargetPolyfill {
    constructor(defaultDuration = DEFAULT_DURATION) {
        super()
        this.defaultDuration = defaultDuration
        this.notifications = []
    }

    createNotification(
        data,
        isPersistent = false,
        createdAt = Date.now(),
        duration = this.defaultDuration,
    ) {
        return {
            data,
            isPersistent,
            createdAt,
            duration,
        }
    }

    removeNotification(notification) {
        const index = this.notifications.indexOf(notification)
        if (index !== -1) {
            this.notifications.splice(index, 1)
        }
        this.dispatchEvent(new CustomEvent('changed'))
        this.dispatchEvent(new CustomEvent('removed', { detail: notification }))
    }

    removeAllNotifications() {
        this.notifications = []
        this.dispatchEvent(new CustomEvent('changed'))
        this.dispatchEvent(new CustomEvent('removed'))
    }

    dispatchNotification(notification) {
        this.notifications.push(notification)
        if (!notification.isPersistent) {
            setTimeout(() => {
                this.removeNotification(notification)
            }, notification.duration)
        }
        this.dispatchEvent(new CustomEvent('changed'))
        this.dispatchEvent(new CustomEvent('added', { detail: notification }))
        return notification
    }

    dispatch(data, isPersistent, createdAt, duration) {
        const notification = this.createNotification(
            data,
            isPersistent,
            createdAt,
            duration,
        )
        this.dispatchNotification(notification)
        return notification
    }

    subscribe(listener) {
        this.addEventListener('changed', () =>
            listener([...this.notifications]),
        )
        return () => {
            this.removeEventListener('changed', () =>
                listener([...this.notifications]),
            )
        }
    }
}

let notificationDispatcher = null
export const getNotificationDispatcher = () => {
    if (notificationDispatcher === null) {
        notificationDispatcher = new NotificationDispatcher()
        return notificationDispatcher
    }
    return notificationDispatcher
}
